<!-- You can use this component as an input in its own right, or you can wrap it around another input
  or other element to still get the warning/error/info message capability and styling -->
<template>
  <div
    class="field"
    :class="{ 'is-clearfix': !stopClearfix }"
  >
    <component :is="labelAsAContainer ? 'label' : 'div'">
      <span class="label is-size-4">{{ label }}</span>
      <div class="control">
        <slot>
          <input
            :is="$attrs.type === 'textarea' ? 'textarea' : 'input'"
            v-bind="$attrs"
            class="is-size-3"
            :class="[inputClass, inputTypeStyle]"
            :value="value"
            :placeholder="placeholder"
            @input="({target}) => $emit('input', target.value)"
            @blur="$emit('blur')"
          />
        </slot>
      </div>
      <span
        v-if="warningText"
        class="is-size-5 is-pulled-right"
      >
        <font-awesome-icon
          color="hsl(48, 100%, 67%)"
          icon="exclamation-triangle"
        />
        {{ warningText }}
      </span>
      <span
        v-else-if="errorText"
        class="is-size-5 is-pulled-right"
      >
        <font-awesome-icon
          v-if="errorText"
          color="hsl(348, 100%, 61%)"
          icon="exclamation-circle"
        />
        {{ errorText }}
      </span>
      <span
        v-else-if="infoText"
        class="is-size-5 is-pulled-left"
      >
        <!-- <font-awesome-icon
          color="hsl(204, 86%, 53%)"
          icon="info-circle"
        /> -->
        {{ infoText }}
      </span>
    </component>
  </div>
</template>

<script>
export default {

  name: 'CustomInput',
  inheritAttrs: false,
  props: {
    // The label name
    label: {
      type: String,
      default: ''
    },

    value: {
      type: [String, Boolean],
      default: ''
    },
    // The default ensures the label wraps around the input. This may cause some strange behaviour
    // for some input types, so you can set this to false in those cases
    labelAsAContainer: {
      type: Boolean,
      default: true
    },
    // Information text to display below the input
    infoText: {
      type: String,
      default: ''
    },
    // Error text to display below the input
    errorText: {
      type: String,
      default: ''
    },
    // Warning text to display below the input
    warningText: {
      type: String,
      default: ''
    },
    // This is the class you want to attach to the input field
    inputClass: {
      type: String,
      default: ''
    },
    // If you don't want an error/warning message to disturb the document flow when it appears,
    // you should set this to true.
    stopClearfix: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputTypeStyle () {
      switch (this.$attrs.type) {
        case 'textarea':
        case 'checkbox':
          return this.$attrs.type
        default:
          return 'input'
      }
    }
  }
}
</script>

<style lang="css" scoped>
.custom-input {
  color: black;
}

.field {
  /* margin-top: 15px;
  margin-bottom: 20px; */
}

</style>
